export type LifecareTerm = {
  agreeKey: 'agree02' | 'agree03' | 'agree04'
  isRequired: boolean
  title: string
  content: string
}

const marketingConsent = `<p><strong>마케팅 정보 수신 동의</strong></p>
<p>주식회사 아정라이프케어는 개인정보보호법 및 정보통신망이용촉진 및 정보보호등에 관한 법률 등 관계법령에 따라 광고성 정보를 전송하기 위해 이용자의 사전 수신동의를 받고 수신 여부를 정기적으로 확인하고 있습니다.</p>
<p>1. 수집 항목</p>
<p>성명, 연락처(휴대전화번호)</p>
<p>2. 수집 방법</p>
<p>홈페이지에서 회원가입 또는 상담신청 화면을 통해 이용자가 직접 입력 및 저장하는 정보 수집</p>
<p>3. 수집 및 활용 목적</p>
<p>① 신규 정책 및 서비스 안내</p>
<p>② 이벤트 및 프로모션 정보 제공</p>
<p>③ 할인혜택, 고객 맞춤형 마케팅 및 판촉 관련 TM 및 SMS 발송</p>
<p>4. 수신 동의 변경 및 보유기간</p>
<p>① 이용자는 회사 정보수정 페이지 또는 고객센터에서 개별서비스의 마케팅 수신동의를 변경(동의/철회)할 수 있습니다.</p>
<p>② 동의일로부터 회원 탈퇴 혹은 마케팅 수신 동의 해제 시까지 광고성 정보 전달을 위하여 보유ㆍ이용 됩니다.</p>
<p>5. 철회안내</p>
<p>① 이용자는 수신동의 이후에라도 언제든지 동의를 철회할 수 있으며, 수신을 동의하지 않아도 회사가 제공하는 기본적인 서비스를 이용하실 수 있습니다. 다만, 수신 거부할 경우 신규 서비스나 상품 관련 소식 등의 마케팅 정보를 제공받지 못할 수 있습니다.</p>
<p>② 단, 회원가입 절차를 완료하지 않은 경우에도, 이용자가 동의한 경우 수집된 정보는 마케팅 목적으로 일정 기간 보관 및 활용될 수 있습니다.</p>
<p>※ 본 마케팅 정보 수신 동의에 대해 거부하실 수 있습니다. 동의하지 않으시더라도 서비스는 정상적으로 이용하실 수 있으나, 마케팅 관련 안내 및 혜택 제공에는 제한이 있을 수 있습니다.</p>`

const privacyPolicy = `<p>아정라이프케어 개인정보 수집 및 활용 동의</p>
<p>주식회사 아정라이프케어(이하 "아정라이프케어"라 합니다)는 서비스 이용에 필요한 최소한의 개인정보를 수집합니다. 이용자의 개인정보와 서비스 방문 및 검색, 서비스 이용을 통해 이용자의 관심, 흥미, 기호 등을 분석하여 개인 성향에 맞춤화 된 서비스를 제공하고 이용자가 원하는 시간, 장소에 맞게 서비스를 제안하는 생활 밀착형 서비스 이용 경험을 제공합니다.</p>
<table style="border: 1px solid #ccc;">
  <tbody>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>분류</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>목적</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>항목</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>보유 및 활용기간</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>필수 정보</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>회원 가입 및 관리, 서비스 상담 및 계약, 신청내역 확인</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>이름, 연락처(휴대전화번호), 생년월일, 성별, 닉네임, 가입채널, 통신사 정보, 주소, 상호, 사업자번호, 서비스 이용을 위한 신청정보</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>개인정보의 수집 또는 제공받는 목적이 달성시까지(단, 관계 법령에 따라 보존이 필요한 경우에는 해당 기간까지 보관한 후 파기)</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>필수 정보</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>사용료 자동이체 및 사은품 지급</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>이름, 연락처(휴대전화번호), 생년월일, 성별, 닉네임, 가입채널, 통신사 정보, 주소, 상호, 사업자번호, 서비스 이용을 위한 신청정보, 계좌번호</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>개인정보의 수집 또는 제공받는 목적이 달성되면 파기(단, 사은품 반환사유가 있을 경우 사은품 반환절차가 완료될 때까지)</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>필수 정보</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>부정 이용 방지</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>서비스 이용 기록, 부정 행위 기록, 녹취 파일</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>부정 이용 행위의 중단 및 관련 민원이나 피해의 해결시까지</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>자동 수집 정보</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>인구통계 정보 및 서비스 이용 이력을 바탕으로 개인화된 마케팅 활동에 활용</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>이메일, 서비스 이용 내용, 상담정보, 광고 전송/반응 정보, 프로모션/이벤트 이용 정보, 이용자 입력 정보</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>개인정보의 수집 또는 제공받는 목적이 달성되면 파기(단, 관계 법령에 따라 보존이 필요한 경우에는 해당 기간까지 보관한 후 파기)</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>자동 수집 정보</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>인구통계 정보 및 서비스 이용 이력을 바탕으로 개인화된 마케팅 활동에 활용</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>접속로그(IP 포함), 쿠키, 서비스이용기록(로그인, 동의 여부, 조회 이력, 기기정보 등)</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>개인정보의 수집 또는 제공받는 목적이 달성되면 파기(단, 관계 법령에 따라 보존이 필요한 경우에는 해당 기간까지 보관한 후 파기)</p>
      </td>
    </tr>
  </tbody>
</table>
<p>* 본 개인정보 수집은 원활한 서비스 가입 및 이용을 위해 진행되고 있으며, 개인정보 수집에 동의하지 않으실 경우 서비스의 가입 및 이용에 제약이 발생할 수 있습니다.</p>`

const privacyThirdParty = `<p>㈜아정라이프케어 개인정보 제3자 제공 및 활용에 대한 동의</p>
<p>주식회사 아정라이프케어(이하 "아정라이프케어"이라 합니다)는 이용자에게 사전 동의를 받은 범위 내에서만 개인정보를 제3자에게 제공합니다. 향후 개인정보를 제공받는 제3자와의 신규 계약 체결, 계약 해지 또는 기타 계약 내용의 변경이 발생할 수 있으며, 이 경우 홈페이지에 게시된 개인정보처리방침을 통해 공지하는 등 관계법령에서 요구하는 절차를 성실히 준수하겠습니다. 현재 아정라이프케어 이용자의 개인정보를 제공하는 제3자는 아래와 같습니다.</p>
<p>1) 개인정보의 제3자 제공</p>
<table style="border: 1px solid #ccc;">
  <tbody>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>제공받는 자</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>제공 목적</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>제공 정보</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>보유 및 이용 기간</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>인터넷 가입 업체, 휴대폰 가입 업체, 렌탈 가입 업체</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>서비스 가입</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>이름, 생년월일, 연락처, 이메일, 주소, 통신사 정보</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>개인정보의 수집 또는 제공받는 목적이 달성되면 파기(단, 관계 법령에 따라 보존이 필요한 경우에는 해당 기간까지 보관한 후 파기)</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>㈜아정네트웍스</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>고객식별, 본인확인, 서비스 가용확인, 고객상담, 유치, 상품소개, 서비스 제공, 접수내용 확인, 기타 고객커뮤니케이션</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>이름, 생년월일, 연락처, 이메일, 주소, 통신사 정보, 가입업체 정보</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>개인정보 수집 또는 제공 목적 달성 시 파기 (단, 관계 법령에 따라 보존 시 해당 기간까지 보관 후 파기)</p>
      </td>
    </tr>
  </tbody>
</table>
<p>* 본 개인정보 제3자 제공 및 활용 동의는 원활한 서비스 가입 및 이용을 위해 진행되고 있으며, 동의하지 않으실 경우 서비스의 가입 및 이용에 제약이 발생할 수 있습니다.</p>
<p>2) 개인정보의 처리위탁</p>
<p>아정라이프케어는 원활한 서비스 제공과 효과적인 업무처리를 위하여 다음과 같이 개인정보를 처리 위탁하고 있습니다.</p>
<p>(1) 개인정보 국내 처리위탁 현황</p>
<table style="border: 1px solid #ccc;">
  <tbody>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>구분</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>수탁자</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>위탁업무</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>보유 및 이용기간</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>전자 결제</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>효성FMS 주식회사,오픈렌탈,BS ON</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>전자 결제 대행</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>관계 법령에 따른 보관의무 기간 또는 회원 탈퇴 및 위탁 계약 종료시까지 보관 후 파기</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>알림 발송</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>BS ON, 오픈렌탈</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>SMS/LMS 및 이메일, 알림톡, 친구톡 발송</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>관계 법령에 따른 보관의무 기간 또는 회원 탈퇴 및 위탁 계약 종료시까지 보관 후 파기</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>데이터 보관</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>아마존웹서비스코리아(유)</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>데이터 보관</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>관계 법령에 따른 보관의무 기간 또는 회원 탈퇴 및 위탁 계약 종료시까지 보관 후 파기</p>
      </td>
    </tr>
    <tr>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>데이터 처리</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>㈜카카오, ㈜네이버</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>마케팅, 서비스 개선</p>
      </td>
      <td valign="top" style="border: 1px solid #ccc;">
        <p>관계 법령에 따른 보관의무 기간 또는 회원 탈퇴 및 위탁 계약 종료시까지 보관 후 파기</p>
      </td>
    </tr>
  </tbody>
</table>`

export const LIFECARE_TERMS: LifecareTerm[] = [
  {
    agreeKey: 'agree02',
    isRequired: true,
    title: '개인정보 제 3자 제공 및 활용 동의 ((주)아정라이프케어)',
    content: privacyThirdParty,
  },
  {
    agreeKey: 'agree03',
    isRequired: true,
    title: '개인정보 수집 및 활용 동의 ((주)아정라이프케어)',
    content: privacyPolicy,
  },
  {
    agreeKey: 'agree04',
    isRequired: false,
    title: '마케팅 정보 수신 동의 ((주)아정라이프케어)',
    content: marketingConsent,
  },
]
